export default __webpack_public_path__ + "static/media/LegendEdriLowRiskDetected.bd514ab7.svg";